module.exports = __webpack_public_path__ + "images/shuffle_grey@3x.png?54019bd0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle_grey@3x.png
// module id = 706
// module chunks = 7